export const formatMetaTitle = (title, name, shortName, delimiter, limit) => {
  const longTitle = title + ' ' + delimiter + ' ' + name
  const shortTitle = title + ' ' + delimiter + ' ' + shortName

  return longTitle.length > limit ? shortTitle : longTitle
}
